export default "__VITE_ASSET__CUGUWYEP__"